import { action } from 'app/actions';

export const GET_QUESTION = 'simulated/questions/GET_QUESTION';
export const GET_QUESTIONS = 'simulated/questions/GET_QUESTIONS';
export const GET_EVALUATION = 'simulated/questions/GET_EVALUATION';
export const APPROVE_EVALUATION = 'simulated/questions/APPROVE_EVALUATION';
export const APPROVE_QUESTION = 'simulated/questions/APPROVE_QUESTION';
export const REPROVE_QUESTION = 'simulated/questions/REPROVE_QUESTION';

export const getQuestions = payload => action(GET_QUESTIONS, { payload });
export const getQuestion = payload => action(GET_QUESTION, { payload });
export const getEvaluation = payload => action(GET_EVALUATION, { payload });
export const approveEvaluation = payload => action(APPROVE_EVALUATION, { payload });
export const reproveQuestion = payload => action(REPROVE_QUESTION, { payload });
export const approveQuestion = payload => action(APPROVE_QUESTION, { payload });
